import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var EmergMed = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.16 18.841h-4.142c.243-.839.375-1.722.375-2.628a9.301 9.301 0 0 0-2.74-6.625 9.31 9.31 0 0 0-6.627-2.738 9.31 9.31 0 0 0-6.629 2.738l-1.402 1.414-1.404-1.403a9.31 9.31 0 0 0-6.628-2.738 9.31 9.31 0 0 0-6.628 2.738c-2.75 2.75-3.424 6.78-2.044 10.17H.83a.834.834 0 0 0-.829.828c0 .453.376.828.829.828h5.346c.332.497.718.972 1.16 1.414L21.41 36.907a.828.828 0 0 0 1.171 0l14.074-14.068a9.519 9.519 0 0 0 1.712-2.341h4.806A.834.834 0 0 0 44 19.67a.844.844 0 0 0-.84-.829ZM8.517 10.77a7.696 7.696 0 0 1 5.457-2.253c1.978 0 3.955.75 5.458 2.253l1.988 1.987c.32.32.85.32 1.171 0l1.988-1.987a7.654 7.654 0 0 1 5.458-2.253 7.7 7.7 0 0 1 5.457 2.253 7.64 7.64 0 0 1 2.264 5.454c0 .906-.165 1.79-.464 2.629h-7.832c-.22 0-.43.088-.585.242l-3.767 3.766-7.534-7.52a.834.834 0 0 0-1.171 0l-4.441 4.428H7.125c-1.513-2.904-1.05-6.57 1.392-9Zm26.966 10.898L21.995 35.151 8.516 21.668c-.077-.077-.143-.165-.22-.243h4.02c.221 0 .431-.088.586-.242L17 17.096l7.523 7.52a.82.82 0 0 0 .586.243.82.82 0 0 0 .585-.243l4.11-4.108h6.65c-.298.409-.619.795-.972 1.16Z"
  }));
});
EmergMed.displayName = 'EmergMed';
EmergMed.defaultProps = {
  'aria-label': 'EmergMed'
};
export default EmergMed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/EmergMed.js
// module id = 3636
// module chunks = 11